// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__QnxK4","footer":"ModalUpdate_footer__xKr52"};